import { render, staticRenderFns } from "./ReceptionPatientCardWithQR.vue?vue&type=template&id=40ae9c13&scoped=true"
import script from "./ReceptionPatientCardWithQR.vue?vue&type=script&lang=js"
export * from "./ReceptionPatientCardWithQR.vue?vue&type=script&lang=js"
import style0 from "./ReceptionPatientCardWithQR.vue?vue&type=style&index=0&id=40ae9c13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ae9c13",
  null
  
)

export default component.exports